
import { timer as observableTimer, Observable, Subject, Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener, Injectable, OnDestroy, AfterContentInit } from '@angular/core';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

import { auditList } from '../../../test-support/auditList';
import { UserProfileService, RaService, DownloadService, dropdownMenuInfo } from '../../../core';
import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';

import { modalComponent } from '../../../common/component/modal/modal.component';
import { ChartComponent } from '../../../common/component/chart/chart.component';
import { JsonPipe } from '@angular/common';
import { routedComponents } from 'app/login/login-routing.module';



@Component({
  selector: 'ra-grid',

  templateUrl: './ra-grid.component.html',
  styleUrls: ['./ra-grid.component.scss']
})


export class RaGridComponent implements OnInit, OnDestroy, AfterContentInit {
  @Output() onDeleteToParent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;
  @ViewChild(ChartComponent, { static: false }) chartController: ChartComponent;

  public openBtnRateIntegrity: boolean = false;
  public accountNameList: Array<string> = [];
  public filteredAccountNameList: Array<string> = [];
  public filteredAccountName;
  public initialFilterStartDate: Date;
  public initialFilterEndDate: Date;
  public filterStartDate;
  public filterEndDate;
  public viewObserver: Observable<GridDataResult>;
  public viewDataSubject:Subject<GridDataResult>  = new Subject<GridDataResult>();
  public set view(data:GridDataResult){
    this.viewDataSubject.next(data)
  }
  public isSuperUser: boolean;
  public state: State = {
    skip: 0,
    take: 10
  };
  public sorted: string = "";
  public result;
  //To save the audit id of the clicked row for deletion
  public auditId = 0;
  public norecords: boolean = true;

  public openChart: boolean = false;
  public ChartData: any[] = [];
  public subTitle;
  public universalAuditID;
  public component;
  public selectedAudit: number[] = [];
  public quickAuditEnabled: boolean = false;
  enableRunningAuditTimer: boolean = false;
  subscriptions: Subscription[] = [];
  public auditCreateMapping: Array<dropdownMenuInfo> = [
    { text: 'Upload File', path: "../create" },
    { text: 'Quick Audit', path: "../quickcreate" }
  ]

  constructor(private raService: RaService
    , private userProfileService: UserProfileService
    , private downloadService: DownloadService
    , private dialogService: DialogService
  ) {
    this.viewObserver = this.viewDataSubject.asObservable();
    // this.raService.query(this.state,this.filterStartDate,this.filterEndDate,this.filteredAccountName).
    // subscribe(data=>{ this.view = data; if(data.total==undefined){this.norecords=false;}else{this.norecords=true;}});
  }

  ngOnInit() {
    this.dialogTitle = "";
    this.dialogTextLine1 = "";
    this.dialogTextLine2 = "";
    this.primaryButtonText = "Ok";
    this.secondaryButtonText = "";

    this.quickAuditEnabled = this.userProfileService.data.ProductAccess.includes("QuickAudit");

    var user = this.userProfileService.data.RoleList;

    if (user[0] == "Super User") {
      this.isSuperUser = true
    } else { this.isSuperUser = false };

    this.initialFilterStartDate = DateTime.now.addDays(-60).toJsDate();
    this.filterStartDate = this.convertDateTomdyyyyFormat(this.initialFilterStartDate);
    this.initialFilterEndDate = DateTime.now.date.toJsDate();
    this.filterEndDate = this.convertDateTomdyyyyFormat(this.initialFilterEndDate);

  }

  ngAfterContentInit() {

    let timer = observableTimer(1000, 20000);
    const s1 = timer.subscribe(t => {
      if (this.showReportDialog)
        return;
      this.raService.query(this.state, this.filterStartDate, this.filterEndDate, this.filteredAccountName)
        .subscribe(data => {
          this.UpdateRunningJobs(data, () => {
            if (data) {
              var index = [sessionStorage.getItem('selectedAudit')];
              this.selectedAudit[0] = parseInt(index[0]);
              this.view = data;
              if (data.total && data.total > 0) {
                this.norecords = true;
              } else {
                this.norecords = false;
              }
            } else {
              this.userProfileService.CheckAndHandleSessionTimeout();
            }
          });
        }
          , err => {
            this.userProfileService.ProcessRiaWcfServiceErrorResponse(err);
          });
    }, err => console.log(err)
      , () => console.log("complete called for Observable.timer(1000,30000)"));

    var dis = this;
    var runningTimer = observableTimer(1000, 5000);
    const s2 = runningTimer.pipe(
      filter(tck => dis.enableRunningAuditTimer))
      .subscribe(tck => dis.UpdateRunningJobs(dis.view, () => { })
      );
    this.refreshAccountNameList();
    this.subscriptions.push(s1, s2);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  refreshAccountNameList() {
    this.raService.GetAccountNameList(this.filterStartDate, this.filterEndDate)
      .subscribe(data => {
        this.accountNameList = data;
      }, err => { console.log(err) });

  }

  ////Display charts
  public onDisplayChart(auditId: any, universalAuditID: any) {
    this.raService.GetRAChart(auditId).
      subscribe(data => {
        this.ChartData = data;
        this.subTitle = "Rate Audit"
        this.universalAuditID = universalAuditID;
        this.component = "RA";
        this.openChart = true;
      });
  }

  public closeChartModals() {
    this.openChart = false;
  }
  showReportDialog: boolean = false;
  reportDlgAuditId: string = "";
  reportDlgLOS: boolean = false;
  onShowReports(auditId: string, LOSAudit: number) {
    this.showReportDialog = true;
    this.reportDlgAuditId = auditId;
    this.reportDlgLOS = LOSAudit != 1;
  }
  reportDialogDone() {
    this.showReportDialog = false;
  }

  selectionChange(event) {
    this.selectedAudit[0] = event.selectedRows[0].dataItem.UniversalAuditID;
    sessionStorage.setItem('selectedAudit', this.selectedAudit[0].toString());
  }

  //To capture the chart icon click event
  @HostListener('click', ['$event'])
  onClick(event) {
    if (event.toElement && event.toElement.className == "cvt-icon-reports grid-cmd-icons") {
      var evt = event ? event : window.event;
      if (evt.stopPropagation) evt.stopPropagation();
      if (evt.cancelBubble != null) evt.cancelBubble = true;
    }
    else {
      return true;
    }
  }
  ///// Dialog box events

  onDownloadRateAuditFile(auditID: string) {
    this.downloadService.downloadRateAuditFile(auditID)
      .subscribe(() => { },
        (err) => {
          this.alertController.showAlertMessage(5000, err, EnumAlertType.Error);
        }
      );
  }

  deleteAudit() {
    this.raService.DeleteAudit(this.auditId.toString())
      .subscribe(r => { this.refreshdata() }, err => { console.log(err) });
  }

  refreshdata() {
    this.raService.query(this.state, this.filterStartDate, this.filterEndDate, this.filteredAccountName)
      .subscribe(data => {
        this.UpdateRunningJobs(data, () => {
          this.view = data;
          if (data.total == undefined) { this.norecords = false; } else { this.norecords = true; }
        });
      });
  }

  UpdateRunningJobs(result: GridDataResult, onComplete: () => void) {

    const running = result.data.filter(q => q.Status == "2");
    if (running && running.length > 0) {
      this.enableRunningAuditTimer = true;
      this.raService.GetRunningStatus(running.map(v => v.AuditID))
        .subscribe(status => {
          running.forEach(d => {
            const s = status.find(q => q.AuditID == d.AuditID);
            if (s) {
              if (s.RequestedJobComplete) {
                d.Status = "3";
              }
              d.AmadeusProgress = s.AmadeusPercentage;
              d.ApolloProgress = s.ApolloPercentage;
              d.GalileoProgress = s.GalileoPercentage;
              d.SabreProgress = s.SabrePercentage;
              d.WorldspanProgress = s.WorldspanPercentage;
            }
          });
          onComplete();
        });
    }
    else {
      this.enableRunningAuditTimer = false;
      onComplete();
    }
  }

  onStartDateChange(value: Date): void {
    this.filterStartDate = this.convertDateTomdyyyyFormat(value);
    this.refreshdata();

    this.refreshAccountNameList();
  }

  onEndDateChange(value: Date): void {
    this.filterEndDate = this.convertDateTomdyyyyFormat(value);;
    this.refreshdata();

    this.refreshAccountNameList();
  }

  handleFilter(value) {
    this.filteredAccountNameList = this.accountNameList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  accountNameFilterChange(value) {
    this.filteredAccountName = value;
    this.refreshdata();


  }



  onDialogDone: Subject<boolean> = null;

  confirmDlg(msg: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = new Subject<boolean>();

    this.secondaryButtonText = cancelButton ? "Cancel" : null;
    return this.onDialogDone.asObservable();
  }

  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.kendoDialog = false;
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
  }

  onDelete(event: any) {
    this.auditId = event;
    this.confirmDlg("Are you sure you want to delete this audit?", "This action cannot be undone", "Delete Audit", true)
      .subscribe(ok => {
        if (ok) {
          this.deleteAudit();
        }
      });
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.sorted = "";
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;
    this.refreshdata();
  }

  convertDateTomdyyyyFormat(date: Date) {
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }
  @ViewChild(modalComponent, { static: false }) modalController: modalComponent;
  dialogTitle: string;
  dialogTextLine1: string;
  dialogTextLine2: string;
  primaryButtonText: string;
  secondaryButtonText: string;

  openModal: boolean = false;
  kendoDialog: boolean = true;

  closeModals(): void {
    this.kendoDialog = false;
    this.openModal = false;
  }

  approveAuditToRun(auditID: string) {
    this.raService.ApproveAuditToRun(auditID)
      .subscribe(msgResult => {
        if (msgResult.success) {
          this.confirmDlg("Selected Audit Was Successfully Approved", "", "Audit Approved", false)
            .subscribe(rtn => {
              this.refreshdata();
            })
        } else {
          this.confirmDlg("Approval failed", msgResult.message, "Error", false);
        }
      });
  }
}
